// Constants
import { TYPES } from '../types/types.constants';
import { initialStateBenefit } from './initial.state';

export const benefitReducer = (state = initialStateBenefit, action) => {

    switch (action.type) {

        case TYPES.BENEFIT.ACTIVATED:
            return {
                ...state,
                activated: {
                    ...action.payload
                }
            }

        case TYPES.BENEFIT.LIST:
            return {
                ...state,
                list: [...state.list, ...action.payload.benefits]
            }

        case TYPES.BENEFIT.RESET_BENEFIT:
            return {
                ...state,
                activated: initialStateBenefit.activated,
                list: initialStateBenefit.list
            }

        case TYPES.APP.RESET:
            return {
                ...initialStateBenefit
            }

        default:
            return state;
    }
};